<template>
  <div class="junhe-activity">
    <img class="logo-img" src="/static/images/junhe/logo.png" alt="logo">

    <div v-if="successJoin == 1" class="rule-card">
      <img class="warning-icon" src="/static/images/junhe/pack.png" alt="warning">
      <div class="rule-title">恭喜你获得积分</div>
      <div class="points-text"><span class="points-number">{{ points }}&nbsp;</span><span class="points-label">积分</span></div>
      <wx-open-launch-weapp id="launch-btn" class="shop-icon" :appid="miniAppId" :username="miniAppOriginalId"
        :path="miniAppPage">
        <script type="text/wxtag-template">
          <img src="https://zishu-image.oss-cn-shanghai.aliyuncs.com/shop-fb450352e108450489661eb15ad63d61.png"
          style="width: 100%;height: auto;display: block;" />
        </script>
      </wx-open-launch-weapp>
    </div>

    <div v-if="successJoin == 2" class="no-border-card">
      <img class="warning-icon" src="/static/images/junhe/ku.png" alt="ku">
      <div class="rule-title">抱歉</div>
      <div class="error-text" v-html="errorMessage"></div>
      <wx-open-launch-weapp id="launch-btn" class="shop-icon" :appid="miniAppId" :username="miniAppOriginalId"
        :path="miniAppPage">
        <script type="text/wxtag-template">
          <img src="https://zishu-image.oss-cn-shanghai.aliyuncs.com/shop-fb450352e108450489661eb15ad63d61.png"
          style="width: 100%;height: auto;display: block;" />
        </script>
      </wx-open-launch-weapp>
    </div>

    <div class="bottom-links">
      <span class="link-text" @click="goToRecord">积分记录</span>
      <span class="link-text" @click="goToRule">规则说明</span>
    </div>
  </div>
</template>

<script>
import { getTemplate, getScoreConfig, registerByOpenId, joinActivity, getJSSDK } from '../../api/api'
import wx from 'weixin-js-sdk'
export default {
  name: 'JunHeActivity',
  data() {
    return {
      successJoin: 0,
      eno: '',
      c: '',
      deptId: '',
      wyAuthCode: '',
      errorMessage: '此码已参与积分<br>感谢您的支持',
      appId: process.env.ENV_NUM === '1' ? 'wx2fd80b8155ff35c2' : 'wxbc22565b3e7a59fd',
      shopUrl: '',
      miniAppId: '',
      miniAppOriginalId: '',
      miniAppPage: '',
      activityId: '',
      userToken: '',
      points: 0
    }
  },
  mounted() {
    // 获取微信JSSDK
    this.getWxJs();
    this.eno = this.$route.query.eno || ''
    this.c = this.$route.query.c || ''
    this.deptId = this.$route.query.deptId || ''
    this.wyAuthCode = this.$route.query.wyAuthCode || ''

    if (this.deptId) {
      this.initPage()
    }
  },
  methods: {
    async initPage() {
      await this.getScoreConfig();
      await this.getTemplate();
    },
    async getScoreConfig() {
      try {
        const res = await getScoreConfig(this.deptId);
        if (res.data.data != null) {
          this.shopUrl = res.data.data.shopUrl;
          const data = this.shopUrl.split('|');
          this.miniAppId = data[0];
          this.miniAppOriginalId = data[1];
          this.miniAppPage = data[2];
        }
      } catch (error) {
        console.error('获取积分配置失败:', error);
      }
    },
    async getTemplate() {
      try {
        const res = await getTemplate(this.deptId)
        if (res.data.code === "200" && res.data.data != null) {
          console.log('Activity页面获取活动模板成功:', res.data.data)

          const { beginTime, endTime, activityId } = res.data.data
          this.activityId = activityId
          const currentTime = new Date()
          const begin = new Date(beginTime.replace(' ', 'T'))
          const end = new Date(endTime.replace(' ', 'T'))

          if (currentTime < begin || currentTime > end) {
            this.successJoin = 2
            this.errorMessage = '活动未开始或已结束<br>请关注后续活动'
            console.log('当前时间不在活动时间范围内')
          } else {
            if (this.activityId) {
              await this.registerUser()
            }
          }
        } else {
          this.successJoin = 2
          this.errorMessage = '暂无可参与的活动'
        }
      } catch (error) {
        this.successJoin = 2
        this.errorMessage = '暂无可参与的活动'
      }
    },
    async registerUser() {
      try {
        const res = await registerByOpenId(this.eno, this.wyAuthCode)
        if (res.data.code === "200") {
          this.userToken = res.data.data.token
          await this.joinActivity()
        } else {
          this.errorMessage = '用户注册失败，请尝试重新扫码'
          this.successJoin = 2
        }
      } catch (error) {
        this.errorMessage = '用户注册失败，请尝试重新扫码'
        this.successJoin = 2
      }
    },
    async joinActivity() {
      try {
        const data = {
          code: this.c,
          activityId: this.activityId,
          authCode: this.wyAuthCode,
          userToken: this.userToken
        }
        const result = await joinActivity(data)
        if (result.data.code === "200") {
          console.log('参与活动成功:', result.data.data)
          const giftValue = result.data.data.giftValue
          this.points = giftValue % 1 === 0 ? Math.floor(giftValue) : giftValue
          this.successJoin = 1
        } else if (result.data.code === "500001") {
          console.log('积分已领取')
          this.successJoin = 2
          this.errorMessage = '此码已参与积分<br>感谢您的支持'
        } else if (result.data.code === "500") {
          let message = result.data.message || ''
          message = message.replace(/java\.lang\.RuntimeException:\s*/g, '')
          this.successJoin = 2
          this.errorMessage = `参与活动失败<br>${message}`
        } else {
          this.successJoin = 2
          this.errorMessage = '参与活动失败<br>请联系客服处理'
        }
      } catch (error) {
        console.error('参与活动失败:', error)
        let message = error.message || ''
        message = message.replace(/java\.lang\.RuntimeException:\s*/g, '')
        this.successJoin = 2
        this.errorMessage = `参与活动失败<br>${message}`
      }
    },
    goToRule() {
      this.$router.push({
        path: '/junhe/rule',
        query: {
          deptId: this.deptId
        }
      })
    },
    goToRecord() {
      this.$router.push({
        path: '/junhe/record',
        query: {
          eno: this.eno,
          userToken: this.userToken,
          deptId: this.deptId
        }
      })
    },
    getWxJs() {
      const url = encodeURIComponent(window.location.href.split('#')[0])
      getJSSDK(url, this.appId).then(res => {
        const data = res.data.data
        wx.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: data.appId, // 必填，公众号的唯一标识
          timestamp: data.timestamp, // 必填，生成签名的时间戳
          nonceStr: data.nonceStr, // 必填，生成签名的随机串
          signature: data.signature,// 必填，签名，见附录1
          openTagList: ["wx-open-launch-weapp", "wx-open-launch-app"],
          jsApiList: [
            'checkJsApi',
            'onMenuShareTimeline',
            'onMenuShareAppMessage',
            'onMenuShareQQ',
            'onMenuShareWeibo',
            'onMenuShareQZone',
            'hideMenuItems',
            'showMenuItems',
            'hideAllNonBaseMenuItem',
            'showAllNonBaseMenuItem',
            'translateVoice',
            'startRecord',
            'stopRecord',
            'onVoiceRecordEnd',
            'playVoice',
            'onVoicePlayEnd',
            'pauseVoice',
            'stopVoice',
            'uploadVoice',
            'downloadVoice',
            'chooseImage',
            'previewImage',
            'uploadImage',
            'downloadImage',
            'getNetworkType',
            'openLocation',
            'getLocation',
            'hideOptionMenu',
            'showOptionMenu',
            'closeWindow',
            'scanQRCode',
            'chooseWXPay',
            'openProductSpecificView',
            'addCard',
            'chooseCard',
            'openCard'
          ] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
        });
        wx.ready(function () {
          wx.hideMenuItems({
            menuList: [
              'menuItem:copyUrl',
              'menuItem:openWithQQBrowse',
              'menuItem:openWithSafari',
              'menuItem:email',
              'menuItem:readMode',
              'menuItem:originPage',
              'menuItem:delete',
              'menuItem:editTag'
            ]
          });
        });

      }).catch(err =>
        alert("获取微信授权失败" + err)
      )
    }
  }
}
</script>

<style scoped>
.junhe-activity {
  position: relative;
  width: 100vw;
  min-height: 100vh;
  background: url("/static/images/junhe/bg.png") no-repeat center top;
  background-size: cover;
}

.logo-img {
  position: absolute;
  top: 3vh;
  right: 8vw;
  width: 20vw;
  height: auto;
}

.bottom-links {
  position: fixed;
  bottom: 4vh;
  left: 0;
  width: 100vw;
  display: flex;
  justify-content: center;
  align-items: center;
}

.link-text {
  color: white;
  font-size: 4vw;
  cursor: pointer;
}

.link-text:first-child {
  margin-right: 15vw;
}

.rule-card {
  position: absolute;
  top: 50vh;
  left: 50%;
  transform: translateX(-50%);
  width: 85vw;
  height: 35vh;
  background: linear-gradient(135deg, rgba(0, 16, 214, 0.8) 0%, rgba(0, 16, 214, 0.5) 10%, transparent 40%), radial-gradient(circle at 100% 100%, rgba(0, 16, 214, 0.8) 0%, rgba(0, 16, 214, 0.3) 10%, transparent 20%);
  border-radius: 25px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 30px 20px;
  position: relative;
}

/* 渐变边框效果 */
.rule-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border-radius: 25px;
  padding: 1px;
  background: linear-gradient(to right, white, gray);
  -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
  -webkit-mask-composite: xor;
  mask-composite: exclude;
  pointer-events: none;
}

.warning-icon {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 18vw;
  height: auto;
  border-radius: 50%;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
}

.no-border-card .warning-icon {
  box-shadow: none;
}

.rule-title {
  color: white;
  font-size: 5vw;
  font-weight: bold;
  margin-top: 4vh;
  margin-bottom: 10px;
}

.points-text {
  font-weight: 900;
}

.points-number {
  font-size: 14vw;
  background: linear-gradient(to right, rgb(3, 255, 255), rgb(4, 203, 255));
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  text-shadow: 0 0 2px rgba(0, 104, 255, 0.6);
  vertical-align: middle;
}

.points-label {
  font-size: 12vw;
  background: linear-gradient(to right, rgb(2, 175, 255), rgb(1, 95, 232));
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  text-shadow: 0 0 2px rgba(0, 104, 255, 0.6);
  vertical-align: middle;
}

.error-text {
  color: white;
  font-size: 4vw;
  text-align: center;
  line-height: 1.5;
  margin-top: 1vh;
}

.shop-icon {
  width: 65vw;
  height: auto;
  margin-top: 1.7vh;
}

.no-border-card {
  position: absolute;
  top: 50vh;
  left: 50%;
  transform: translateX(-50%);
  width: 85vw;
  min-height: 35vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 30px 20px;
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/components/JunHe/Activity.vue